import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import colors from '/@/components/theme-provider/colors.js';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';

const FieldCard = ({ field, setField, onClick, selected, disabled }) => {
    return (
        <Grid
            container
            direction='column'
            sx={{
                border: '1px solid #E1E1E1',
                px: 2,
                py: 3,
                borderRadius: 2,
                ...(field.id == selected && {
                    backgroundColor: colors.themes[settings.app.theme].primary[200],
                }),
            }}
        >
            <Grid item sx={{ mb: 2 }}>
                <Grid container alignItems='center' spacing={1}>
                    <Grid item>
                        <Title size='sm' theme={!disabled && settings.app.theme} color={disabled && 'gray-light'}>
                            <i style={{ fontSize: '20px' }} className='material-icons'>
                                layers
                            </i>
                        </Title>
                    </Grid>
                    <Grid item sx={{ mb: 1 }}>
                        <Title size='sm' className='mp-mask'>
                            {field.name}
                        </Title>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item sx={{ mb: 2 }} spacing={1}>
                <Grid container alignItems='center'>
                    <Grid item xs={1}>
                        <Title size='sm' theme={!disabled && settings.app.theme} color={disabled && 'gray-light'}>
                            <i style={{ fontSize: '20px' }} className='material-icons'>
                                location_on
                            </i>
                        </Title>
                    </Grid>
                    <Grid item xs={11}>
                        <Title size='sm' color={disabled && 'gray'}>
                            {field.location}
                        </Title>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container alignItems='center' spacing={2}>
                    <Grid item xs={6}>
                        <Button onClick={() => setField(field)} variant='contained' disabled={disabled} fullWidth>
                            {_('Ver en el mapa')}
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button onClick={() => onClick(field.id)} disabled={disabled} variant='contained' fullWidth>
                            {_('Seleccionar')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default FieldCard;
